const CHATBOT_OPEN_EVENT = 'chatbot:open';
const TRIGGER_SELECTOR = '.hero-home__assistant-btn';
const NAV_SELECTOR = '#mainNav';

const closeMobileNav = () => {
  const navElement = document.querySelector(NAV_SELECTOR);

  if (!(navElement instanceof HTMLElement) || !navElement.classList.contains('show')) {
    return;
  }

  const bootstrapApi = window.bootstrap;

  // Support both collapse and offcanvas implementations of the mobile menu.
  if (bootstrapApi?.Offcanvas && navElement.classList.contains('offcanvas')) {
    const offcanvasInstance = bootstrapApi.Offcanvas.getOrCreateInstance(navElement);
    offcanvasInstance.hide();
    return;
  }

  if (bootstrapApi?.Collapse) {
    const collapseInstance = bootstrapApi.Collapse.getOrCreateInstance(navElement);
    collapseInstance.hide();
    return;
  }

  navElement.classList.remove('show');
  document.body.classList.remove('menu-open');
};

export const initChatbotTrigger = () => {
  if (document.body.dataset.chatbotTriggerBound === 'true') {
    return;
  }

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const triggerButton = target.closest(TRIGGER_SELECTOR);

    if (!triggerButton) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    closeMobileNav();
    window.dispatchEvent(new CustomEvent(CHATBOT_OPEN_EVENT));
  });

  document.body.dataset.chatbotTriggerBound = 'true';
};
